'use strict';

var cov_ackw3b5ia = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/resaleAvailability/lib/index.js',
      hash = '74056e8ec077540dee73e83c4245119502b2edc9',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/resaleAvailability/lib/index.js',
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResaleAvailabilityType = exports.ResaleAvailabilityModel = undefined;

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _type = require('./type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ResaleAvailabilityModel = _model2.default;
exports.ResaleAvailabilityType = _type2.default;
exports.default = { reducer: _reducer2.default, actions: _actions2.default };